import {
	INITIAL_INVENTORY_REQUEST,
	FINAL_INVENTORY_REQUEST,
	FETCH_INVENTORY_SUCCESS,
	UPDATE_INVENTORIES,
	CHANGE_SELECT_INVENTORIES,
	CHANGE_TAGS_AVAILABLE,
} from "../types/inventory.types";

const initialState = {
	inventories: [],
	products: [],
	aptitudes: [],
	active_ingredients: [],
	cas: [],
	formulas: [],
	dealers: [],
	tags_available: [],
	lots_available: [],
	inventories_print: [],
	permissions: [],
	selected: [],
	quantity: 0,
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: true,
	message: "",
	error: null,
};

function inventories(state = initialState, action) {
	switch (action.type) {
		case INITIAL_INVENTORY_REQUEST:
			return {
				...state,
				isFetching: true,
				message: action.payload && action.payload.message ? action.payload.message : "",
				error: null,
			};
		case FINAL_INVENTORY_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		case FETCH_INVENTORY_SUCCESS:
			return {
				...state,
				isFetching: false,
				inventories: action.payload.inventories,
				products: action.payload.products,
				aptitudes: action.payload.aptitudes,
				active_ingredients: action.payload.active_ingredients,
				business: action.payload.business,
				cas: action.payload.cas,
				formulas: action.payload.formulas,
				dealers: action.payload.dealers,
				quantity: action.payload.quantity,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				permissions: action.payload.permissions,
			};
		case UPDATE_INVENTORIES:
			return {
				...state,
				inventories: action.payload.inventories,
			};
		case CHANGE_SELECT_INVENTORIES:
			return {
				...state,
				selected: action.payload.selected,
			};
		case CHANGE_TAGS_AVAILABLE:
			return {
				...state,
				tags_available: action.payload.tags_available,
				lots_available: action.payload.lots_available,
			};

		default:
			return state;
	}
}

export default inventories;
